import QRCodeReact from "qrcode.react";
import Logo from '../../images/Restaurant_QRCode.png'

const QRGenerator = ({ value, documentId }) => {
  // console.log(value, documentId);
  return (
    <QRCodeReact
      id={documentId}
      value={value}
      size={200}
      bgColor='#fff'
      fgColor="#000"
      level="M"
      includeMargin={true}
      // imageSettings={{
      //   src: "/icon.png",
      //   x: undefined,
      //   y: undefined,
      //   height: 60,
      //   width: 60,
      //   excavate: true,
      // }}
    />
  )
}
export default QRGenerator;